// extracted by mini-css-extract-plugin
export var animStatsContainer = "FlyoverMapStats-module__animStatsContainer___Bi1fj";
export var animStat = "FlyoverMapStats-module__animStat___nT0FR";
export var statTitle = "FlyoverMapStats-module__statTitle___V1nTK";
export var stat = "FlyoverMapStats-module__stat___CP_vn";
export var controlsEnter = "FlyoverMapStats-module__controlsEnter___MOhOY";
export var controlsEnterActive = "FlyoverMapStats-module__controlsEnterActive___b4eXq";